import { render, staticRenderFns } from "./confirm-contract.html?vue&type=template&id=63b613f0&scoped=true&external"
import script from "./confirm-contract.js?vue&type=script&lang=js&external"
export * from "./confirm-contract.js?vue&type=script&lang=js&external"
import style0 from "./confirm-contract.scss?vue&type=style&index=0&id=63b613f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b613f0",
  null
  
)

export default component.exports